import requestV2 from '@/service/request-v2'

export type ReminderType = 0 | 1 | 2 | 3
export type ConfigValueType = 'BOOLEAN' | 'INTEGER' | 'STRING' | 'JSON'

export interface RealtimeReminderConfigFilters {
  corpId: string
  reminderType: ReminderType | ''
}

export interface RealtimeReminderConfigPayload {
  configKey: string
  configValue: string
  corpId: string
  description: string
  enabled: number
  reminderType: ReminderType
  valueType: ConfigValueType
}

export interface RealtimeReminderConfig extends RealtimeReminderConfigPayload {
  id: number | string
  createdAt: string
  updatedAt: string
  updatedBy: string
  versionNo: number
}

export async function fetchRealtimeReminderConfigs(
  filters: RealtimeReminderConfigFilters,
  signal?: AbortSignal
) {
  const params: Record<string, string | number> = {}
  if (filters.corpId) params.corpId = filters.corpId
  if (filters.reminderType !== '') params.reminderType = filters.reminderType

  const payload = await requestV2.get<unknown>({
    url: '/main/realtime-reminder/configs',
    params,
    signal
  })
  if (!Array.isArray(payload)) throw new Error('实时提醒配置响应必须是数组')
  return payload as RealtimeReminderConfig[]
}

export function createRealtimeReminderConfig(
  payload: RealtimeReminderConfigPayload
) {
  return requestV2.post<RealtimeReminderConfig>({
    url: '/main/realtime-reminder/configs',
    data: payload
  })
}

export function updateRealtimeReminderConfig(
  id: RealtimeReminderConfig['id'],
  payload: RealtimeReminderConfigPayload
) {
  return requestV2.put<RealtimeReminderConfig>({
    url: `/main/realtime-reminder/configs/${id}`,
    data: payload
  })
}

export function deleteRealtimeReminderConfig(
  id: RealtimeReminderConfig['id']
) {
  return requestV2.delete<void>({
    url: `/main/realtime-reminder/configs/${id}`
  })
}
